import { useState } from 'react';
import { FaCheck } from 'react-icons/fa';

import { useCreateConsentMutation, useGetPatientConsentsQuery } from '../../app/services/insurance';
import { toast } from 'react-toastify';
import Modal from '../Modal/Modal';
import { useGetWebflowTermsQuery } from '../../app/services/webflow';

//This function asks them to consent to billing their insurance for RPM and Coaching
function RPMConsent() {
    //Queries
    const { data: consents } = useGetPatientConsentsQuery();
    const [createConsent] = useCreateConsentMutation();
    const { data: webflowTerms } = useGetWebflowTermsQuery();

    //Find the previous consent if it exists
    const previousConsent = consents?.results.find((c) => c.documentType === 'rpm-consent');

    //Local state
    const [submitting, setSubmitting] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    //Find the RPM consent from webflow
    const rpmConsent = webflowTerms?.items?.find((t) => t.slug === 'rpm-consent');

    return (
        <div className="relative flex items-center space-x-4 sm:space-x-2 justify-center pb-4">
            <label className="relative inline-flex items-center">
                <input
                    type="checkbox"
                    disabled={submitting}
                    checked={previousConsent ? previousConsent.accepted : true}
                    onChange={async (e) => {
                        e.preventDefault();
                        try {
                            setSubmitting(true);

                            await createConsent([
                                {
                                    id: rpmConsent._id,
                                    version: '' + rpmConsent?.version,
                                    name: rpmConsent.name,
                                    documentType: rpmConsent.slug,
                                    accepted: e.target.checked,
                                },
                            ]);

                            setSubmitting(false);
                        } catch {
                            toast.error('Something went wrong, try again');
                        }
                    }}
                    className="peer h-6 w-6 border-4 bg-transparent appearance-none border-green-400 checked:bg-green-600 checked:border-green-600 transition duration-200 focus:outline-none hover:cursor-pointer"
                    style={{
                        backgroundColor:
                            !previousConsent || previousConsent?.accepted
                                ? '#107e40'
                                : 'transparent',
                    }}
                />

                {!previousConsent || previousConsent?.accepted ? (
                    <FaCheck className="absolute left-1 top-1 pointer-events-none w-4 h-4 text-white transition" />
                ) : null}
            </label>
            <p>
                I consent to participate in{' '}
                <span
                    className="link block sm:inline-block"
                    onClick={() => {
                        setModalOpen(true);
                    }}>
                    Remote Patient Monitoring (RPM)
                </span>
            </p>
            <Modal showClose={true} isOpen={modalOpen} closeHandler={() => setModalOpen(false)}>
                {rpmConsent ? (
                    <div
                        className="pt-8 sm:max-w-2xl "
                        dangerouslySetInnerHTML={{
                            __html: rpmConsent['main-content'],
                        }}></div>
                ) : null}
            </Modal>
        </div>
    );
}

export default RPMConsent;
